import angular from 'angular'
import selectTreeDirective from './selectTreeDirective'

export default angular
    .module('app.selectTree2', [])
    .directive('selectTree2', selectTreeDirective)
    .name



// WEBPACK FOOTER //
// ./src/components/selectTree2/index.js